module.exports = __webpack_public_path__ + "img/Jump.ff6874f9.svg";